import axios from "axios";
import config from "../config";

export interface SiteDetails {
  iwsSiteDetailsPk: number;
  custName: string;
  siteFk: number;
  syncoId: string;
  custNmbr: string;
  adrsCode: string;
  contractNumber: string;
  equipmentId: string;
}

export interface SiteRules {
  id: number;
  customerName: string;
  addressCode: string;
  quantityOfHits: number;
  averageDuration: number;
  impactEquip: number;
  impactComfort: number;
  energySaving: number;
  equipment: string;
  resourceType: string;
  analyticRule: string;
  enabled: boolean;
  skysparkUrl: string;
  dateSinceLastOccurrence: string;
  daysSinceLastOccurrence: number;
}

export interface SparkType {
  sparkTypeName: string;
}

export interface Templates {
  templatePk: number;
  sparkTypeEntity: SparkType;
  resourceType: number;
  impactEquip: number;
  impactComfort: number;
  estimatedSavings: number;
  enabled: boolean;
}

export interface SparkType {
  sparkTypeName: string;
}

// GET request for SITE DETAILS
export const getSiteDetails = (
  syncoId: string,
  callback?: (data: SiteDetails) => void,
  handleError?: (error: {data: string, url: string}) => void
) => {
  axios
    .get<SiteDetails>(`${config.iwsRouteBase}${config.iwsUrlPrefix}/${syncoId}/synco`, {
      url: `${config.iwsUrlPrefix}/${syncoId}/synco`,
      baseURL: `${config.iwsRouteBase}`,
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      if (callback) {
        callback(response.data);
      }
    })
    .catch((ex) => {
      if(ex.response) {
        if (handleError) {
          handleError({data:ex.response.data, url: ex.response.config.url});
        }
      }
      else if(handleError) {
        handleError({data:"Network error", url: "undefined"});
      }
    });
};

// POST request for SITE DETAILS
export const postSiteDetails = (
  syncoId: string,
  siteDetails: SiteDetails,
  callback?: (data: SiteDetails) => void,
  handleError?: (error: {data: string, url: string}) => void
) => {
  axios
    .post<SiteDetails>(`${config.iwsRouteBase}${config.iwsUrlPrefix}/${syncoId}/update/synco`, siteDetails, {
      url: `${config.iwsUrlPrefix}/${syncoId}/update/synco`,
      baseURL: `${config.iwsRouteBase}`
    })
    .then((response) => {
      if (callback) {
        callback(response.data);
      }
    })
    .catch((ex) => {
      if(ex.response) {
        if (handleError) {
          handleError({data:ex.response.data, url: ex.response.config.url});
        }
      }
      else if(handleError) {
        handleError({data:"Network error", url: "undefined"});
      }
    });
};

// GET request for SITE RULES
export const getSiteRules = (
  syncoId: string,
  callback?: (data: SiteRules[]) => void,
  handleError?: (error: {data: string, url: string}) => void
) => {
  axios
    .get<SiteRules[]>(`${config.iwsRouteBase}${config.iwsUrlPrefix}/${syncoId}/rules/synco`, {
      url: `${config.iwsUrlPrefix}/${syncoId}/rules/synco`,
      baseURL: `${config.iwsRouteBase}`,
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      if (callback) {
        callback(response.data);
      }
    })
    .catch((ex) => {
      if(ex.response) {
        if (handleError) {
          handleError({data:ex.response.data, url: ex.response.config.url});
        }
      }
      else if(handleError) {
        handleError({data:"Network error", url: "undefined"});
      }
    });
};

// POST request for SITE RULES
export const postSiteRules = (
  syncoId: string,
  siteRules: SiteRules[],
  callback: (data: SiteRules[]) => void,
  handleError?: (error: {data: string, url: string}) => void
) => {
  axios
    .post<SiteRules[]>(
      `${config.iwsRouteBase}${config.iwsUrlPrefix}/${syncoId}/rules/update/synco`,
      siteRules, {
        url: `${config.iwsUrlPrefix}/${syncoId}/rules/update/synco`,
        baseURL: `${config.iwsRouteBase}`
      }
    )
    .then((response) => {
      if (callback) {
        callback(response.data);
      }
    })
    .catch((ex) => {
      if(ex.response) {
        if (handleError) {
          handleError({data:ex.response.data, url: ex.response.config.url});
        }
      }
      else if(handleError) {
        handleError({data:"Network error", url: "undefined"});
      }
    });
};


// GET request for Templates
export const getTemplateDetails = (
  syncoId: string,
  callback?: (data: Templates[]) => void,
  handleError?: (error: {data: string, url: string}) => void
) => {
  axios
    .get<Templates[]>(`${config.iwsRouteBase}${config.iwsUrlPrefix}/${syncoId}/templates/synco`, {
      url: `${config.iwsUrlPrefix}/${syncoId}/templates/synco`,
      baseURL: `${config.iwsRouteBase}`,
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      if (callback) {
        callback(response.data);
      }
    })
    .catch((ex) => {
      if(ex.response) {
        if (handleError) {
          handleError({data:ex.response.data, url: ex.response.config.url});
        }
      }
      else if(handleError) {
        handleError({data:"Network error", url: "undefined"});
      }
    });
};

export const postTemplateDetails = (
  syncoId: string,
  templates: Templates[],
  callback: (data: Templates[]) => void,
  handleError?: (error: {data: string, url: string}) => void
) => {
  axios
    .post<Templates[]>(
      `${config.iwsRouteBase}${config.iwsUrlPrefix}/${syncoId}/templates/update/synco`, templates, {
        url: `${config.iwsUrlPrefix}/${syncoId}/templates/update/synco`,
        baseURL: `${config.iwsRouteBase}`,
      })
    .then((response) => {
      if (callback) {
        callback(response.data);
      }
    })
    .catch((ex) => {
      if(ex.response) {
        if (handleError) {
          handleError({data:ex.response.data, url: ex.response.config.url});
        }
      }
      else if(handleError) {
        handleError({data:"Network error", url: "undefined"});
      }
    });
};
